import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";
import Reveal from "./Reveal";

export default function FAQ() {
  const { t } = useTranslation();
  const FAQS = t("faq.items", { returnObjects: true });

  return (
    <section id="faq" data-testid="faq-section" className="max-w-4xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
      <Reveal className="text-center">
        <div className="text-xs uppercase tracking-[0.28em] text-[#F5CB5C] font-semibold">{t("faq.kicker")}</div>
        <h2 className="mt-4 font-display text-white text-2xl sm:text-3xl lg:text-4xl">{t("faq.title")}</h2>
        <p className="mt-4 text-sm sm:text-base text-gray-400">
          {t("faq.desc")}
        </p>
      </Reveal>

      <Reveal delay={0.15} className="mt-10">
        <Accordion type="single" collapsible className="glass-card rounded-3xl px-5 sm:px-8">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#F5CB5C]/10 last:border-0">
              <AccordionTrigger
                data-testid={`faq-accordion-trigger-${i}`}
                className="text-left font-display text-white text-sm sm:text-base py-5 hover:text-[#F5CB5C] hover:no-underline transition-colors [&[data-state=open]>svg]:rotate-180 [&>svg]:text-[#F5CB5C] [&>svg]:transition-transform [&>svg]:duration-300"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-accordion-content-${i}`} className="text-sm text-gray-400 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
